<div [formGroup]="form" class="grid grid-nogutter">
  <div class="col-12 p-fluid">
    <p *ngIf="documentErrorKey" class="p-error" role="alert">{{ documentErrorKey | translate }}</p>
    <p-fileUpload [customUpload]="true" [auto]="false" [multiple]="true" accept="image/*,application/*,text/*" [maxFileSize]="maxDocumentFileSizeBytes" (onUpload)="onTemplatedUpload()" (onSelect)="onSelectedFiles($event)" >
      <ng-template pTemplate="header" let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback" let-uploadCallback="uploadCallback">
        <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2 sticky-uploader-bar">
          <div class="flex gap-2">
            <p-button (onClick)="choose($event, chooseCallback)" icon="pi pi-images" [rounded]="true" [outlined]="true" />
            <p-button (onClick)="uploadEvent(uploadCallback)" icon="pi pi-cloud-upload" [rounded]="true" [outlined]="true" severity="success" [disabled]="!files || files.length === 0" />
            <p-button (onClick)="clearEvent(clearCallback)" icon="pi pi-times" [rounded]="true" [outlined]="true" severity="danger" [disabled]="!files || files.length === 0" />
          </div>
          <p-progressBar [value]="totalSizePercent" [showValue]="false" styleClass="md:w-20rem h-1rem w-full md:ml-auto" [ngClass]="{ 'exceeded-progress-bar': totalSizePercent > 100 }">
            <span class="white-space-nowrap">{{ totalSize }}B / 50MB</span>
          </p-progressBar>
        </div>
      </ng-template>
      <ng-template pTemplate="content" let-files let-uploadedFiles="uploadedFiles" let-removeFileCallback="removeFileCallback" let-removeUploadedFileCallback="removeUploadedFileCallback">
        <div *ngIf="pendingDocuments?.length > 0" formArrayName="pendingDocuments" class="p-1">
          <p-progressBar [value]="uploadProgress" [showValue]="false" styleClass="width-100 document-upload-progress" [ngClass]="{ 'exceeded-progress-bar': uploadProgress > 100, 'width-100': true }">
          </p-progressBar>
          <h5 class="p-3 m-0">{{ 'shared.modal.modal_service.add_documents.pending'|translate }}</h5>
          <div class="flex flex-wrap p-0 sm:p-5 gap-5 width-100">
            <div [formGroupName]="i" *ngFor="let document of pendingDocuments.controls; index as i; let isLast = last; let isFirst = first" class="card overflow-hidden width-100 m-0 my-1 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
              <div class="width-100">
                <img *ngIf="document.get('file').value?.type.startsWith('image/')" role="presentation" [alt]="(document.get('file').value?.name || document.get('originalName').value)" [src]="document.get('file').value.objectURL" width="100%"/>
                <img *ngIf="document.get('file').value?.type === 'application/pdf'" role="presentation" [alt]="(document.get('file').value?.name || document.get('originalName').value)" [src]="document.get('file').value.thumbnail" width="100%"/>
              </div>
              <div class="font-semibold text-overflow-ellipsis white-space-nowrap">{{ (document.get('file').value?.name || document.get('originalName').value) }}</div>
              <div>{{ formatSize(document.get('size').value) }}</div>
              <p-badge [value]="'shared.modal.modal_service.add_documents.pending'|translate" severity="warning" />
              <textarea pInputTextarea [autoResize]="true" formControlName="description"></textarea>
              <p-button icon="pi pi-times" (onClick)="onRemoveTemplatingFile($event, document, removeFileCallback, i)" [outlined]="true" [rounded]="true" severity="danger" />
            </div>
          </div>
        </div>
        <div *ngIf="uploadedDocuments?.length > 0" formArrayName="uploadedDocuments" class="p-1">
          <h5 class="p-3 m-0">{{ 'shared.modal.modal_service.add_documents.completed'|translate }}</h5>
          <div [formGroupName]="i" *ngFor="let document of uploadedDocuments.controls; index as i; let isLast = last; let isFirst = first" class="card overflow-hidden width-100 m-0 my-1 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
            <div class="width-100">
              <img *ngIf="document.get('file').value?.type === 'application/pdf'" role="presentation" [alt]="(document.get('file').value?.name || document.get('originalName').value)" [src]="document.get('file').value.thumbnail" width="100%"/>
            </div>
            <div class="font-semibold text-overflow-ellipsis white-space-nowrap">{{ (document.get('file').value?.name || document.get('originalName').value) }}</div>
            <div>{{ formatSize(document.get('size').value) }}</div>
            <p-badge [value]="document.get('createdAt').value" severity="warning" />
            <textarea pInputTextarea [autoResize]="true" formControlName="description"></textarea>
            <p-button icon="pi pi-times" (onClick)="onRemoveTemplatingFile($event, document, removeFileCallback, i)" [outlined]="true" [rounded]="true" severity="danger" />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="file"> </ng-template>
      <ng-template *ngIf="windowWidth >768" pTemplate="empty">
        <div class="flex align-items-center justify-content-center flex-column p-5">
          <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400"></i>
          <p class="mt-4 mb-0">{{'common.drag_and_drop_to_upload'|translate}} <!--Drag and drop files here to upload.--></p>
        </div>
      </ng-template>
    </p-fileUpload>

<!--    <div *ngIf="form.get('email').invalid && form.get('email').touched"-->
<!--         class="app-form-error">-->
<!--      <p>{{ form.get('email')['errorMessage'] }}</p>-->
<!--      <p *ngIf="form.get('email').errors?.custom">{{ form.get('email').errors?.custom }}</p>-->
<!--    </div>-->
  </div>
<!--  <div class="col-12 md:col-6 p-2">-->
<!--    <div class="width-100 p-fluid p-float-label p-input-icon-left">-->
<!--      <p-calendar-->
<!--        [formControlName]="'from'"-->
<!--        [showIcon]="true"-->
<!--        inputId="ownerFrom"-->
<!--        icon="pi pi-calendar"-->
<!--        dateFormat="dd.mm.yy"-->
<!--        [appendTo]="'body'"-->
<!--      />-->
<!--      <label for="ownerFrom">{{ 'feature.user.project.owner_from' | translate }}</label>-->
<!--      <div *ngIf="form.get('from').invalid && form.get('from').touched"-->
<!--           class="app-form-error">-->
<!--        <p>{{ form.get('from')['errorMessage'] }}</p>-->
<!--        <p *ngIf="form.get('from').errors?.custom">{{ form.get('from').errors?.custom }}</p>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="col-12 md:col-6 p-2">-->
<!--    <div class="width-100 flex justify-content-center align-items-center mb-2">-->
<!--      <p-inputOtp [formControlName]="'pin'" [integerOnly]="true" [length]="6" />-->
<!--    </div>-->
<!--    <div *ngIf="form.get('pin').invalid && form.get('pin').touched"-->
<!--         class="app-form-error">-->
<!--      <p>{{ form.get('pin')['errorMessage'] }}</p>-->
<!--      <p *ngIf="form.get('pin').errors?.custom">{{ form.get('pin').errors?.custom }}</p>-->
<!--    </div>-->
<!--    <small>{{'shared.modal.component.change_main_owner.otp.help'|translate }}</small>-->
<!--  </div>-->
</div>


